import { makeStyles } from '@mui/styles';
import { body1, body2 } from '../../../shared/theme/text.styles';

export const useAuthorAStyles = makeStyles((theme) => ({
  aaName: {
    ...body1,
  },

  aaDate: {
    ...body2,
  },

  videoIcon: {
    backgroundColor: `${theme.palette.background.main} !important`,
    fontSize: '32px'
  },
  blogIcon: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    fontSize: '32px'
  },
}));
